export enum RecordingSource {
  VOICEMAIL = "VOICEMAIL",
  CALL = "CALL",
}
